export const TABS_PANEL_ID = 'cap-contained-tabs-panel';
